import React, { Component } from 'react'
import { Div, P, H6 } from '@driftt/tide-core'
import { Icon } from '@driftt/tide-icons'
import { DragDropContext } from 'react-dnd'
import HTML5Backend from 'react-dnd-html5-backend' 
import { prop, sortBy } from 'ramda'
import { EmptyState } from '@driftt/crm-components'
import Draggable from 'components/Settings/Draggable'
import DragDropHandleSVG from 'images/drag-drop.svg'

import './style.css'

const SidebarCard = ({iconWidth, iconHeight, title, children }) => {
  return (
    <Div className="settings-card">
      <Div className="settings-card-header">
        <Div className="settings-card-header--title-and-icon">
          {title}
        </Div>
      </Div>
      <Div className="settings-card-body">
        {children}
      </Div>
    </Div>
  )
}

class SettingsSidebarPreview extends Component {

  renderDefaultDisplay = () => {
    return (
      <div className="settings-sidebar-preview--null-list">
        <EmptyState
          bottomText="Check the boxes of attributes you want to display in the sidebar to get started."
          topText="No Attributes Selected"
        />
      </div>
    )
  }

  renderPropertiesPreview = () => {
    const { config, exampleContact, onReorderSidebarAttributes, onReorderSidebarCards } = this.props

    const sortedConfig = sortBy(prop('displayIndex'), config)

    return sortedConfig.map((card, cardIndex) =>
      <Draggable
        type={'CARD'}
        id={cardIndex}
        onReorder={onReorderSidebarCards}
        key={card.cardName}
      >
        <div className="settings-sidebar--cards">
          <SidebarCard
            hasSettings={false}
            title={
              <Div className="settings-sidebar-preview-card-title">
                <Div className="move-handle">
                  <img alt={'drag drop handle'} src={DragDropHandleSVG} width={10} height={10} />
                </Div>
                <H6>{card.cardName}</H6>
              </Div>
            }
            key={`${card.cardName}-${card.id}`}
          >
            {card.attributes.map((attribute, index) =>
              <Draggable
                type={'ATTRIBUTE'}
                id={index}
                onReorder={onReorderSidebarAttributes}
                key={`attribute-${index}-${attribute.name}`}
                currentSettingsObject={card.cardName}
              >
                <div className="field-row">
                  <Div className="move-handle">
                    <img alt={'drag drop handle'} src={DragDropHandleSVG} width={10} height={10} />
                  </Div>
                  <Div>
                    <Div className="field-row-label">
                      {attribute.displayName}
                    </Div>
                    <Div className="field-row-value">
                      {exampleContact[attribute.name] ? exampleContact[attribute.name] : exampleContact.attributes[attribute.name]}
                    </Div>
                  </Div>
                </div>
              </Draggable>
            )}
          </SidebarCard>
        </div>
      </Draggable>
    )
  }

  render() {
    const { isEmpty } = this.props
    return (
      <Div className="settings-sidebar-preview-section">
        <Div className="settings-sidebar-preview-header">
          <Icon height={24} name="rolodex" width={24} />
          <H6>About</H6>
          <H6>Preview</H6>
        </Div>
        <P>These contact attributes will appear on every contact record you view.</P>
        <Div className="card-section">
          {isEmpty ? this.renderDefaultDisplay() : this.renderPropertiesPreview()}
        </Div>
      </Div>
    )
  }
}

export default DragDropContext(HTML5Backend)(SettingsSidebarPreview)
